import { ReactElement, useEffect, useState } from 'react'
import {
  FlexWrapper,
  PageWrapper,
  SectionTitle,
  Button,
  TableWrapper,
  TableHeader,
  TostMessage,
  Loader,
  Modal
} from '../../../../components'
import strings from '../../../../locale/en'
import { useHistory } from 'react-router-dom'
import ROUTES from '../../../../const/routes'
import { CourseFilterSection, CourseAction, TableRow } from '../subcomponents'
import { Table } from 'react-bootstrap'
import { tableHeader } from './const'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../../redux/store'
import {
  deleteCourse,
  getAllCourses,
  getChildCourses,
  getCourse,
  resetError,
  resetSubjects,
  resetChapters,
  resetTopics,
  setSelectedCourse
} from '../../../../redux/course/action'
import getCoursesDropdown, {
  getAllCoursesDropdown
} from '../../../../helpers/getCoursesDropdown'
import { DropdownListProps } from '../../../../components/EditableDropdown/typings'
import { FormBackWrapper } from '../../User/subcomponents'

const CourseList = (): ReactElement => {
  const {
    isLoading,
    courses,
    error,
    courseDetails,
    subjects,
    chapters,
    topics
  } = useSelector(
    (state: RootState) => ({
      isLoading: state.course.isLoading,
      courses: state.course.courses,
      error: state.course.error,
      courseDetails: state.course.courseDetails,
      subjects: state.course.subjects,
      chapters: state.course.chapters,
      topics: state.course.topics
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const history = useHistory()
  const [parentName, setParentName] = useState('')
  const [deleteCourseId, setDeleteCourseId] = useState('')
  const courseList = courseDetails ? getAllCoursesDropdown(courseDetails) : []
  const subjectList = subjects ? getCoursesDropdown(subjects) : []
  const chapterList = chapters ? getCoursesDropdown(chapters) : []
  const tableList = topics?.length
    ? topics
    : chapters?.length
      ? chapters
      : subjects?.length
        ? subjects
        : courses?.length
          ? courses
          : []

  const {
    menu: {
      course: {
        courseListing,
        add,
        modal: { title }
      }
    }
  } = strings

  const fetchCourseList = () => {
    dispatch(
      getAllCourses({
        pageNumber: 1,
        pageSizeNumber: 100
      })
    )
  }

  const handleCourseSelect = (item: DropdownListProps) => {
    dispatch(resetSubjects())
    dispatch(resetChapters())
    dispatch(resetTopics())
    dispatch(
      getChildCourses({
        courseId: item?.id,
        type: 'SUBJECT'
      })
    )
    setParentName(item.name)
  }

  const handleSubjectSelect = (item: DropdownListProps) => {
    dispatch(resetChapters())
    dispatch(resetTopics())
    dispatch(
      getChildCourses({
        courseId: item?.id,
        type: 'CHAPTER'
      })
    )
    setParentName(item.name)
  }

  const handleChapterSelect = (item: DropdownListProps) => {
    dispatch(
      getChildCourses({
        courseId: item?.id,
        type: 'TOPICS'
      })
    )
    setParentName(item.name)
  }

  useEffect(() => {
    dispatch(getCourse())
    fetchCourseList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageWrapper id="container">
      <FlexWrapper hasBorder justifyContent="space-between">
        <SectionTitle title={courseListing} />
        <Button onClick={() => history.push(ROUTES.ADDCOURSE)}>{add}</Button>
      </FlexWrapper>
      <TostMessage
        show={!!error}
        onCloseHandler={() => dispatch(resetError())}
        message={error}
      />
      <CourseFilterSection
        courseList={courseList}
        handleCourseSelect={handleCourseSelect}
        subjectList={subjectList}
        handleSubjectSelect={handleSubjectSelect}
        chapterList={chapterList}
        handleChapterSelect={handleChapterSelect}
      />
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <FormBackWrapper>
            <TableWrapper>
              <Table size="sm" responsive="sm">
                <TableHeader>
                  <TableRow>
                    {tableHeader?.map((header, index) => (
                      <th key={`course-header-${index}`}>{header}</th>
                    ))}
                  </TableRow>
                </TableHeader>
                <tbody>
                  {tableList.map((course, index) => {
                    const { id, courseName, status, description } = course
                    return (
                      <TableRow key={`course-list-${index}`}>
                        <td>{parentName}</td>
                        <td>{courseName}</td>
                        <td>{description}</td>
                        <td>{status}</td>
                        <td>
                          <CourseAction
                            handleView={() => {
                              dispatch(setSelectedCourse(course))
                              history.push(ROUTES.VIEW_COURSE)
                            }}
                            handleEdit={() => {
                              dispatch(setSelectedCourse(course))
                              history.push(ROUTES.EDIT_COURSE)
                            }}
                            handleDelete={() => {
                              setDeleteCourseId(id)
                            }}
                          />
                        </td>
                      </TableRow>
                    )
                  })}
                </tbody>
              </Table>
            </TableWrapper>
          </FormBackWrapper>
        </div>
      )}
      {deleteCourseId && (
        <Modal
          handleCancel={() => {
            setDeleteCourseId('')
          }}
          handleSubmit={() => {
            dispatch(deleteCourse(deleteCourseId))
            setDeleteCourseId('')
          }}
          title={title}
        />
      )}
    </PageWrapper>
  )
}

export default CourseList
